import { render } from "./SecurityBody.vue?vue&type=template&id=2d6bf873"
import script from "./SecurityBody.vue?vue&type=script&lang=js"
export * from "./SecurityBody.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__